import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@sharedModule/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationCommonDialogData } from '@sharedModule/models/confirmation-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  constructor(public dialog: MatDialog) {}

  openConfirmationDialog(
    confirmationAlertData?: ConfirmationCommonDialogData
  ): Promise<boolean> {
    return new Promise(resolve => {
      const matDialogConfig: MatDialogConfig = {
        width:
          confirmationAlertData && confirmationAlertData.width
            ? confirmationAlertData.width
            : '350px',
        height:
          confirmationAlertData && confirmationAlertData.height
            ? confirmationAlertData.height
            : 'auto',
        data: confirmationAlertData,
        panelClass: ['animated', 'slideInDown'],
      };
      const dialogRef = this.dialog.open(
        ConfirmationDialogComponent,
        matDialogConfig
      );
      dialogRef.afterClosed().subscribe(result => {
        resolve(result ? true : false);
      });
    });
  }
}
